import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './context/AuthContext';
import { CodProvider } from './context/CodContext';
import Login from './components/Login';
import Register from './components/Register';
import Home from './components/Home';
import {RankingList} from './components/Ranking';
import { WinnerRanking } from './components/Ranking';
import AddPoints from './components/AddPoints';
import CreateEvent from './components/CreateEvent';
import Events from './components/Events'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import DEV_TOOLS_DEV from './DevTools'
import Qr from './components/Qr';

const App = () => {
  useEffect(() => {
    if (DEV_TOOLS_DEV === 'prod') {
      // Desactivar clic derecho
      const disableRightClick = (event) => {
        event.preventDefault();
      };
      document.addEventListener('contextmenu', disableRightClick);

      // Prevenir teclas de acceso rápido para DevTools
      const disableDevToolsShortcuts = (event) => {
        if (event.keyCode === 123 || (event.ctrlKey && event.shiftKey && (event.keyCode === 73 || event.keyCode === 74)) || (event.ctrlKey && event.keyCode === 85)) {
          event.preventDefault();
        }
      };
      document.addEventListener('keydown', disableDevToolsShortcuts);

      // Cleanup event listeners on component unmount
      return () => {
        document.removeEventListener('contextmenu', disableRightClick);
        document.removeEventListener('keydown', disableDevToolsShortcuts);
      };
    }
  }, []);


  return (
    <AuthProvider>
      <CodProvider>
        <Router>
          <Routes>
            <Route path="/qr" element={<Qr />} />
            <Route path="/login" element={<Login />} />
            <Route path="/registro" element={<Register />} />
            <Route path='/ranking' element={<RankingList />} />
            <Route path='/winners' element={<WinnerRanking />} />
            <Route path='/crear-evento' element={<RequireAuth><CreateEvent /></RequireAuth>} />
            <Route path='/events' element={<RequireAuth><Events /></RequireAuth>} />
            <Route path='/agregarPuntos' element={<RequireAuth><AddPoints /></RequireAuth>} />
            <Route path="*" element={<Navigate to="/registro" />} />
          </Routes>
        </Router>
      </CodProvider>
    </AuthProvider>
  );
};

export default App;
